export default __webpack_public_path__ + "static/media/art-slt-banner-2.d8b0528b.jpg";